import { mirrorItems } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function MirrorSection() {
  return (
    <section id="mirrors" className="w-full border-b border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          index="04"
          label="Mirrors"
          title="镜像与备用节点汇总"
          desc="各节点按地区分布并列展示，包含在线状态、可用率与当前负载，主入口不可用时可按地区就近选择，换链接防走丢更省心。"
          extra={
            <div className="flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-2 text-xs font-label text-foreground-600">
                <span className="h-2 w-2 rounded-full bg-secondary-500"></span>在线
              </span>
              <span className="inline-flex items-center gap-2 text-xs font-label text-foreground-600">
                <span className="h-2 w-2 rounded-full bg-accent-500"></span>维护
              </span>
            </div>
          }
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {mirrorItems.map((item) => {
            const online = item.status === '在线';
            return (
              <div
                key={item.id}
                className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-secondary-300"
              >
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-3">
                    <span
                      className={
                        online
                          ? 'flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700'
                          : 'flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-800'
                      }
                    >
                      <i className="ri-server-line text-lg" aria-hidden="true"></i>
                    </span>
                    <div>
                      <p className="font-heading text-base font-bold text-foreground-950">{item.node}</p>
                      <p className="mt-0.5 text-xs font-label text-foreground-500">{item.type}</p>
                    </div>
                  </div>
                  <span
                    className={
                      online
                        ? 'inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-label text-secondary-800'
                        : 'inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-label text-accent-900'
                    }
                  >
                    <span className={online ? 'h-1.5 w-1.5 rounded-full bg-secondary-500' : 'h-1.5 w-1.5 rounded-full bg-accent-500'}></span>
                    {item.status}
                  </span>
                </div>

                <dl className="mt-5 grid grid-cols-2 gap-3 border-t border-background-200 pt-4">
                  <div>
                    <dt className="text-[11px] font-label text-foreground-500">地区</dt>
                    <dd className="mt-1 text-sm font-label text-foreground-900">{item.region}</dd>
                  </div>
                  <div>
                    <dt className="text-[11px] font-label text-foreground-500">30 天可用率</dt>
                    <dd className="mt-1 text-sm font-label text-foreground-900">{item.uptime}</dd>
                  </div>
                </dl>

                <div className="mt-4">
                  <div className="flex items-center justify-between text-[11px] font-label text-foreground-500">
                    <span>当前负载</span>
                    <span>{item.load}%</span>
                  </div>
                  <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <span
                      className="block h-full rounded-full bg-secondary-500/80"
                      style={{ width: `${item.load}%` }}
                    ></span>
                  </div>
                </div>

                <a
                  href="#entries"
                  className="mt-5 inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-label text-foreground-800 transition-colors hover:border-secondary-400 hover:text-secondary-700"
                >
                  选择该节点
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
                  </span>
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}